import { Box, TextField, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from '../elearning.module.css'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

function ViewAllHistory() {
    const navigate = useNavigate()
    const location = useLocation()
    const [search, setSearch] = useState('')
    const [historyFinishAll, setHistoryFinishAll] = useState([])
    const [historyAll, setHistoryAll] = useState([])

    useEffect(() => {
        let data = location.state.item
        // console.log(data)
        setHistoryFinishAll(data)
        setHistoryAll(data)
    }, [])

    const handleClickSearch = () => {
        if (search === '') {
            setHistoryFinishAll(historyAll)
        } else {
            const filteredItems = historyAll.filter((item) =>
                item.e_learning_name.toLowerCase().includes(search.toLowerCase())
            )
            setHistoryFinishAll(filteredItems)
        }
    }

    return (
        <>
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/manageUserELearning') }}
                    >กลับไป ห้องเรียนออนไลน์</Box>
                </Box>
                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    display: 'flex',
                    padding: '5px'
                }}>
                    <TextField
                        fullWidth
                        variant="standard"
                        sx={{
                            ...InputCSS
                        }}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        placeholder="พิมพ์ข้อความเพื่อค้นหาข้อมูล..."
                        value={search}
                        onChange={(e) => { setSearch(e.target.value) }}
                    />
                    <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
                </Box>

                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gridGap: '10px',
                    "@media (max-width: 1000px)": {
                        gridTemplateColumns: '1fr 1fr',
                    },
                    "@media (max-width: 600px)": {
                        gridTemplateColumns: '1fr',
                    }
                }}>
                    {historyFinishAll.map((item, index) => (
                        <Box sx={{
                            border: '1px solid #2F327D1A',
                            boxShadow: '2px 2px 10px #2F327D1A',
                            backgroundColor: '#ffffff',
                            borderRadius: '10px',
                            padding: '10px',
                            // cursor: 'pointer',
                            display: 'grid',
                            gridGap: '5px'
                        }}
                            key={index}
                        >
                            <Box sx={{
                                width: '100%',
                                height: '200px',
                                "@media (max-width: 1000px)": {
                                    height: '150px',
                                }
                            }}>
                                <img src={item['e_learning_image']} style={{ width: '100%', borderRadius: '10px', height: 'inherit', objectFit: 'cover' }} />
                            </Box>
                            <Box sx={{ fontWeight: 600 }}>{item['e_learning_name']}</Box>
                            <Box className={styles.ellipsis}>{item['e_learning_detail']}</Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </>
    )
}

export default ViewAllHistory

const InputCSS = {
    padding: '5px',
    border: 'none',
    '&.MuiInputBase-root': {
        border: 'none'
    },
    '&.MuiInputBase-root:focus': {

    }
}
